import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { type ForwardedRef, forwardRef } from 'react';
import styles from './Card.module.css';
import { CardProps, CommonCardProps } from './types';
const Card = forwardRef(function Card(t0, ref) {
  const $ = _c(15);
  let children;
  let className;
  let props;
  let size;
  let t1;
  if ($[0] !== t0) {
    ({
      as: t1,
      className,
      children,
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = size;
    $[5] = t1;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    size = $[4];
    t1 = $[5];
  }
  const Tag = t1 === undefined ? "div" : t1;
  const t2 = props as CommonCardProps;
  const t3 = styles[`size-${size}`];
  let t4;
  if ($[6] !== className || $[7] !== t3) {
    t4 = classNames(styles.container, className, t3);
    $[6] = className;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = ref as ForwardedRef<any>;
  let t6;
  if ($[9] !== Tag || $[10] !== children || $[11] !== t2 || $[12] !== t4 || $[13] !== t5) {
    t6 = <Tag {...t2} className={t4} ref={t5}>{children}</Tag>;
    $[9] = Tag;
    $[10] = children;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
});
export default Card;